<template>
  <div class="autocomplete-field">
    <v-text-field
      flat
      solo
      required
      class="mt-2"
      v-model="query"
      :readonly="readonly"
      @input="$emit('input', query)"
      @change="$emit('input', query)"
      @keyup="onKeyupLocation($event)"
      @keydown.esc="selectPlaylist(-1)"
      :error-messages="inputError"
      placeholder="Search"
    ></v-text-field>

    <ul class="autocomplete-list" v-if="playlists">
      <li
        class="autocomplete-list-item d-flex"
        v-for="(item, index) in playlists"
        :key="index"
        :item="item"
        @click="selectPlaylist(index)"
        @keydown.esc="selectPlaylist(-1)"
      >
        <div v-if="item" class="d-flex">
          <span class="mr-3" v-if="item.images.length > 0">
            <v-img
              class="rounded-sm"
              height="30"
              width="30"
              :src="item.images[0].url"
            ></v-img>
          </span>
          <span class="autocomplete-list-item-label">
            {{ item.name }} ({{ item.tracks.total }} tracks )
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
import _ from 'lodash'

export default {
  props: {
    accessToken: String,
    value: String,
    inputError: Array,
    readonly: Boolean,
    all: Boolean
  },

  data() {
    return {
      query: '',
      playlists: null
    }
  },

  watch: {
    value(value) {
      this.query = value

      if (!this.query) {
        this.$emit('select', null)
      }
    }
  },

  created() {
    this.query = this.value
  },

  methods: {
    onKeyupLocation(e) {
      this.search(e.target.value)
    },

    search: debounce(function(query) {
      this.searchSpotifyPlaylist(query)
    }, 600),

    selectPlaylist(index) {
      this.select(this.playlists[index])
      this.reset()
    },

    select(playlist) {
      this.query = `${playlist.name} (${playlist.tracks.total} tracks)`
      this.$emit('input', this.query)
      this.$emit('select', playlist)
      this.$emit('input', '')
    },

    async searchSpotifyPlaylist(query) {
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${this.accessToken}`
      }

      const $url = `https://api.spotify.com/v1/search?q=${query}&type=playlist,album`
      await axios
        .get($url, {
          headers: headers
        })
        .then(({ data }) => {
          this.playlists = data.playlists.items.concat(
            data.albums.items.map(item => {
              item.tracks = { total: item.total_tracks }
              return item
            })
          )
          this.playlists = this.playlists.map(item => {
            item.nameCopy = item.name.toLowerCase()
            return item
          })

          this.playlists = this.sortPlaylists(this.playlists, query)
        })
        .catch(() => {
          this.loading = false
        })
    },

    sortPlaylists(playlists, query) {
      return _.orderBy(
        playlists,
        [
          // First sort by whether name starts with query
          item => item.nameCopy.startsWith(query.toLowerCase()),
          // Then sort by whether name includes query
          item => item.nameCopy.includes(query.toLowerCase()),
          // Then sort alphabetically by name
          item => item.nameCopy
        ],
        ['desc', 'asc', 'asc']
      )
    },

    reset() {
      this.playlists = null
      this.query = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.autocomplete-list {
  margin: 0;
  padding: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  list-style-type: none;
  border-radius: 6px;
  z-index: 99;
  position: absolute;
  background: #fff;
  overflow: hidden;
  text-align: left;
  top: 50px;
  width: 400px;
}

.autocomplete-list-item {
  padding: 8px 15px;
  list-style: none;
}
.autocomplete-list-item.selected,
.autocomplete-list-item:hover {
  cursor: pointer;
  background-color: #f8f9fa;
}

.autocomplete-field {
  position: relative;
}
</style>
